import classNames from 'classnames';
import type { ReactElement, Ref, RefObject } from 'react';
import { useRef } from 'react';
import type { PlayIconProps, PlayIconRef } from './PlayIcon.data';
import { defaultButtonSize } from './PlayIcon.data';
import styles from './PlayIcon.module.scss';

export default function PlayIcon({
  isPlaying,
  className,
  size,
  ref,
}: PlayIconProps & { ref?: Ref<PlayIconRef> }): ReactElement {
  const localRef = useRef(null);
  const elementRef = (ref || localRef) as RefObject<HTMLDivElement | null>;

  return (
    <div
      ref={elementRef}
      className={classNames(
        styles.playIcon,
        className,
        styles[`size-${size ?? defaultButtonSize}`],
        {
          [styles.isPlaying]: isPlaying,
        },
      )}
    >
      <span className={styles.icon} />
    </div>
  );
}
